<script lang="ts"></script>

<script setup lang="ts">
import { ref } from "vue";
import APIClient from "@/APIClient";
import router from "@/router";
import { useTogglePassword } from "@/composable/useTogglePassword";
import { EMAIL_RG_PATTERN, getErrorMessage } from "@/utils/misc.utils";
import LoadingPrimaryButton from "@/components/generic/LoadingPrimaryButton.vue";
import { Logger } from "@/logger";

const privacyPolicyURL = import.meta.env.DR_PRIVACY_POLICY_URL || "";
const termsOfServiceURL = import.meta.env.DR_TERMS_OF_SERVICE_URL || "";

const email = ref("");
const password = ref("");

const isLoading = ref(false);
const showError = ref("");

const { toggle, refPwdHook, isPwdToggled } = useTogglePassword();

async function login() {
  isLoading.value = true;
  try {
    await APIClient.login(email.value, password.value);
    Logger.identify();
    router.replace({ name: "home" });
    Logger.info(`Login.vue : user ${email.value} logged in`);
    isLoading.value = false;
  } catch (error) {
    isLoading.value = false;
    Logger.error(`Login.vue : Couldn't log in: ${JSON.stringify(error)}`);
    showError.value = getErrorMessage(error, {
      auth: "Avez-vous créé un compte à cet adresse mail ? Si c'est le cas, vérifiez la syntaxe de votre adresse et mot de passe.",
    });
  }
}
</script>

<template>
  <form @submit.prevent="login" id="login-form">
    <div class="form-floating my-3">
      <input
        v-model="email"
        type="email"
        class="form-control"
        id="email"
        :pattern="EMAIL_RG_PATTERN"
        :placeholder="$t('email')"
        required
      />
      <label for="email">{{ $t("email") }}</label>
    </div>
    <div class="input-group mb-3">
      <div class="form-floating">
        <input
          ref="refPwdHook"
          v-model="password"
          type="password"
          class="form-control"
          id="password"
          required
          :placeholder="$t('password')"
        />
        <label for="password">{{ $t("password") }}</label>
      </div>
      <span @click="toggle" class="input-group-text">
        <i v-if="isPwdToggled" class="bi bi-eye-slash"></i>
        <i v-else class="bi bi-eye"></i>
      </span>
    </div>

    <router-link :to="{ name: 'forgot' }">
      {{ $t("auth:login.form.forgot_password") }}
    </router-link>
    <div class="text-center mt-2">
      <LoadingPrimaryButton :isLoading="isLoading">
        {{ $t("auth:login.form.submit") }}
      </LoadingPrimaryButton>
    </div>
  </form>
  <div v-if="showError !== ''" class="alert alert-danger mt-3" role="alert">
    {{ showError }}
  </div>

  <div class="text-center mt-3" style="font-size: 0.8em">
    {{ $t("auth:login.accept_terms_1") }}
    <a :href="termsOfServiceURL" target="_blank">
      {{ $t("auth:login.terms_of_service") }}
    </a>

    {{ $t("auth:login.accept_terms_2") }}
    <a :href="privacyPolicyURL" target="_blank">
      {{ $t("auth:login.privacy_policy") }}
    </a>
  </div>
</template>
